import { helpers } from '@vuelidate/validators';
import { validateCpf } from '@utils/validateCpf';

export const cpfRule = helpers.withParams(
  { message: 'CPF Inválido' },
  (value: string) => {
    if (!value) return true;

    // Remove non-digit characters
    const normalizedValue = value.replace(/\D/g, '');

    if (normalizedValue.length !== 11) return false;

    return validateCpf(normalizedValue);
  }
);
